<template>
  <div id="Student_Organizations">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>

    <usc-intro>
      <p slot="p">Follow your passions, grow your network and gain invaluable experience by participating in Marshall’s numerous undergraduate student organizations.</p>
    </usc-intro>

    <div class="body mb gutter-lg">
      <p><i>These student-led groups reflect nearly every academic area within Marshall and often engage with industry experts and alumni. You’ll interact socially and professionally with students and renowned executives as you develop business-critical skills such as leadership, teamwork and project management.</i></p>
      <p>Marshall holds an involvement fair each semester where you can meet representatives from the school’s wide range of student organizations. In the meantime, take a look online at the currently <a class="inline-hyperlink" href="https://www.marshall.usc.edu/current-students/leadership-development-and-student-organizations/marshall-recognized-student-organizations">recognized Marshall student organizations</a>. There’s something for everyone — and you also have the option of forming your own group!</p>
      <p>Industry-specific groups include Accounting Society, Consulting Club, Data Analytics Club, Marshall Entertainment Association, Fashion Industry Association, International Consulting Club, Marshall Real Estate Finance Association, American Marketing Association, Operations Management Association and the Sports Business Association — just to name a few. Affinity groups range from the Black Business Student Association and Korean Business Student Organization to the Latino Business Student Association and Marshall Women’s Leadership Board.</p>
      <p>The Marshall Business Student Government serves as a liaison between the school’s administration and student body, and advocates for an inclusive and resourceful community. Marshall Student Ambassadors are undergraduate representatives who support prospective and current students.</p>
      <p>In addition, Marshall students can join any of the more than 1,000 university-wide student organizations to expand your network even further. Getting involved in student groups complements your classroom activities and rounds out your Marshall education.</p>
      <p></p>
      <usc-cta slot="cta-bottom" text="Explore Campus Activities" url="https://campusactivities.usc.edu/"></usc-cta>
    </div>

    <div class="body gutter-lg mb">
      <p><strong>Get Involved!</strong></p>
      <img src="../../../static/CL-get-involved-24.png" alt="1k USC student Organizations and 60% USC students who volunteer" title="" style="width: 100%;"/>
    </div>

  </div>
</template>

<script>
import Hero from '@/components/Hero'
import Intro from '@/components/Intro'
import Cta from '@/components/Cta'
import VideoEmbed from '@/components/videoEmbed'
import ListImage from '@/components/ListImage'
import VueTinySlider from 'vue-tiny-slider'

export default {
  name: 'StudentOrganizations',
  components: {
    'usc-hero': Hero,
    'usc-intro': Intro,
    'usc-cta': Cta,
    'usc-video': VideoEmbed,
    'usc-list-image': ListImage,
    'tiny-slider': VueTinySlider
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Student Organizations',
        loResSrc: '../../../static/HeroImages/CampusLife-Marshall32.jpg',
        hiResSrc: '../../../static/HeroImages/CampusLife-Marshall32.jpg'
      },
      slideIndex: 1,
      prevDisabled: true,
      nextDisabled: false,
      slides: [
        {
          image: '/static/Opportunities_Student_Organizations_1.jpg',
          alt: 'Students gathered around a professor in front of a computer',
          id: 0
        },
        {
          image: '/static/Opportunities_Student_Organizations_2.jpg',
          alt: 'Student speaking outside to a gathering of other students',
          id: 1
        },
        {
          image: '/static/Opportunities_Student_Organizations_3.jpg',
          alt: 'Two USC students sitting at a table',
          id: 2
        }
      ]
    }
  },
  created () {
    this.$root.setPageHeader('Opportunities', 'Student Organizations')
  },
  methods: {
    prevSlide () {
      if (this.slideIndex > 1) {
        this.slideIndex--
      } else {
        this.prevDisabled = true
      }
    },
    nextSlide () {
      if (this.slideIndex < this.totalSlides) {
        this.slideIndex++
      } else {
        this.nextDisabled = true
      }
    }
  },

  computed: {
    totalSlides () {
      return this.slides.length
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~tiny-slider/src/tiny-slider';
</style>



// WEBPACK FOOTER //
// src/pages/life-at-marshall/StudentOrganizations.vue